import RegistrationExpiredOverlay from "@pathwright/web/src/modules/registration/expired/RegistrationExpiredOverlay"
import capitalize from "lodash/capitalize"
import { DESIGN, LEARN, PREVIEW, TEACH } from "path/constants"
import PropTypes from "prop-types"
import React from "react"
import "./LibraryResource.css"
import LibraryResourceTheme from "./LibraryResourceTheme"
import ResourceHeader from "./header/ResourceHeader"
import PathProvider from "./path/state/PathProvider"

class LibraryResource extends React.Component {
  static initClass() {
    this.childContextTypes = {
      mode: PropTypes.oneOf([PREVIEW, LEARN, TEACH, DESIGN]),
      permissions: PropTypes.object
    }
  }

  getChildContext() {
    return {
      mode: this.props.mode,
      permissions: this.props.permissions
    }
  }

  render() {
    const { isLoading, offering, section, communityArea, resource } = this.props

    const sectionClassName = `LibraryResource__${capitalize(section)}`

    const resourceClass = resource ? ` Resource__${resource.id}` : ""

    return (
      <PathProvider>
        <div className={`LibraryResource${resourceClass}`}>
          <LibraryResourceTheme>
            {!isLoading ? (
              <>
                {!!offering && (
                  <RegistrationExpiredOverlay cohortId={offering.id} />
                )}
                {!!offering.parent_offering_id && (
                  <RegistrationExpiredOverlay
                    cohortId={offering.parent_offering_id}
                  />
                )}
                <ResourceHeader communityArea={communityArea} />
                <div className={sectionClassName}>{this.props.children}</div>
              </>
            ) : null}
          </LibraryResourceTheme>
        </div>
      </PathProvider>
    )
  }
}
LibraryResource.initClass()

LibraryResource.displayName = "LibraryResource"

export default LibraryResource
